<template>
  <CFooter :fixed="true" style="height:75px">
   <CRow class="my-1 p-0 col-sm-12 col-md-8 col-lg-6 " >
      <CCol>
        <span class="badge badge-success p-1"
          >آنلاین <br/> 250<CIcon name="cil-car-alt" width="48" color="red"
        /></span>
      </CCol>

      <CCol >
        <span class="badge badge-danger p-1"
          >آفلاین <br/> 250<CIcon name="cil-car-alt" width="48" color="red"
        /></span>
      </CCol>
      <CCol >
        <span class="badge badge-warning p-1"
          >عدم دسترسی <br/> 250<CIcon name="cil-car-alt" width="48" color="red"
        /></span>
      </CCol>

      <CCol >
        <span class="badge badge-secondary p-1"
          >خارج از دسترس <br/> 250<CIcon name="cil-car-alt" width="48" color="red"
        /></span>
      </CCol>

      <!-- <CCol col="12" sm="6" lg="3">
          <CWidgetIcon
            header="$1.999,50"
            text="Income"
            color="gradient-danger"
            :icon-padding="false"
          >
            <CIcon name="cil-bell" width="24" />
          </CWidgetIcon>
        </CCol> -->
    </CRow>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
